import { createUseStyles } from "react-jss";
import { controlBackgroundColor, alpha, foregroundColor, darken } from "../../../theme/Mixins";

export default createUseStyles({
    choice: {
        background: ({ theme }) => alpha(theme.ControlBackground, theme.ControlAlpha),
        border: ({ theme }) => [[theme.BorderWidth, "solid", theme.ControlBorderColor]],
        borderRadius: ({ theme }) => theme.BorderRadius,
        color: ({ theme }) => foregroundColor(theme, controlBackgroundColor(theme)),
        composes: "choice radio-button",
        cursor: "pointer",
        flex: 1,
        outline: "none",
        position: "relative",
        textAlign: "center",
        transition: "background 200ms, border-color 200ms, color 200ms",
        margin: 3,

        "&:before": {
            content: "''",
            float: "left",
            paddingTop: "100%",
        },
    },
    dynamicChoice: {
        width: "100%",
        margin: ({ theme }) => [[theme.ChoiceSpacing / 2, 0]],
        padding: [[14.5, 0]],

        "&:before": {
            paddingTop: "0",
            height: 29,
            width: "100%",
        },
    },
    choiceSelected: {
        background: ({ theme }) => theme.PrimaryColor,
        borderColor: ({ theme }) => darken(theme.PrimaryColor, theme.ActiveHighlightValue),
        color: ({ theme }) => foregroundColor(theme, theme.PrimaryColor),
        composes: "choice--selected",
    },
    choiceActive: {
        background: ({ theme, selected }) =>
            selected
                ? darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                : darken(theme.ControlBackground, theme.ActiveBackgroundValue),
        composes: "choice--active",
        color: ({ theme, selected }) => {
            return selected
                ? foregroundColor(theme, darken(theme.PrimaryColor, theme.ActiveHighlightValue))
                : foregroundColor(
                      theme,
                      darken(theme.ControlBackground, theme.ActiveBackgroundValue),
                  );
        },
    },
    content: {
        alignItems: "center",
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        left: 0,
        position: "absolute",
        right: 0,
        top: 0,
    },
});
